import { getAddressString } from "@msuite/utils/strings";
import type { Tables } from "@msuite/utils/types";

/** Props Interface */
export interface ProjectsComboboxItemProps<T extends Tables<"projects">> {
	item: T;
}

export function ProjectsComboboxItem<T extends Tables<"projects">>(
	props: ProjectsComboboxItemProps<T>,
) {
	/** Render */
	return (
		<div className="gap-0 w-full v-stack self-stretch">
			<div className="justify-between h-stack w-full gap-4">
				<p className="font-medium line-clamp-1 text-sm">{props.item.name}</p>
				<p className="text-primary-500! text-xs shrink-0 line-clamp-1">{props.item.number}</p>
			</div>
			<p className="line-clamp-1 text-primary-500! text-xs shrink-0">
				{getAddressString(props.item)}
			</p>
		</div>
	);
}
